module.exports = __webpack_public_path__ + "static/img/8.5d9fce3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/zh/8.png
// module id = CiMV
// module chunks = 0